<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>
  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">
      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto">
        <div class="card bg-white rounded-5 shadow border-0 mt-5 card-nav-tabs">
          <div class="card-header rounded-5 card-header-primary">
            <div class="nav-tabs-navigation">
              <div class="nav-tabs-wrapper">
                <ul class="nav nav-tabs text-xxs" id="appform-tabs" role="tablist">
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'sections' }"
                    @click="activeTab = 'sections'"
                    id="tab-sections"
                    data-bs-toggle="tab"
                    data-bs-target="#pane-sections"
                    type="button"
                    role="tab"
                    aria-controls="pane-sections"
                    :aria-selected="activeTab === 'sections'"
                  >
                    Sections
                  </button>

                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'preview' }"
                    @click="activeTab = 'preview'"
                    id="tab-preview"
                    data-bs-toggle="tab"
                    data-bs-target="#pane-preview"
                    type="button"
                    role="tab"
                    aria-controls="pane-preview"
                    :aria-selected="activeTab === 'preview'"
                  >
                    Preview Application Form
                  </button>
                </ul>
              </div>
            </div>
          </div>

          <div v-show="activeTab === 'preview'">
            <FormView/>
          </div>

          <div class="card-body tab-content" id="sectionTabsContent">
            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>

            <div v-show="activeTab === 'sections'">
              <div class="card border-0 p-1 rounded-5">
                <div class="d-flex justify-content-start align-items-center">
                  <button class="btn btn-warning text-white text-xxs rounded-5 shadow-lg fw-500" data-bs-toggle="modal"
                    data-bs-target="#create_section">
                    <i class='bx bx-plus'></i> Create Section
                  </button>
                  <router-link :to="'/assign_sections/' + form_id">
                  <button class="btn btn-warning text-white text-xxs rounded-5 shadow-lg fw-500 ms-2" >
                    <i class='bx bx-plus'></i> Assign Section
                  </button>
                  </router-link>
                </div>
              </div>
              <table id="questionsTable" class="table table-striped text-xxs mt-3">
                <thead class="btn-primary text-white">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Section Name</th>
                    <th scope="col">Locked</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody class="text-black">
                  <tr v-for="(section, index) in sections" :key="section.id" class="border-section">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ section.name }}</td>
                    <td>
                      <span v-if="section.is_locked" class="badge bg-danger text-white">Locked</span>
                      <span v-else class="badge bg-success text-white">Unlocked</span>
                    </td>
                    <td>
                      <!-- Assign Questions -->
                      <router-link
                        :to="'/assign_questions/' + section.id"
                        class="btn btn-light btn-sm rounded-3 border text-primary mx-1 shadow-sm"
                        role="button"
                        aria-label="Assign questions"
                      >
                        <i class="bi bi-eye me-1"></i>
                        <span class="text-xxs">Assign Questions</span>
                      </router-link>

                      <!-- Edit -->
                      <button
                        class="btn btn-light btn-sm rounded-3 border text-success mx-1 shadow-sm"
                        data-bs-toggle="modal"
                        :data-bs-target="'#edit_section_' + section.id"
                        @click="editSectionName(section)"
                        aria-label="Edit section"
                      >
                        <i class="bi bi-pencil-square me-1"></i>
                        <span class="text-xxs">Edit</span>
                      </button>

                      <!-- Delete -->
                      <button
                        @click="deleteSection(section.id)"
                        class="btn btn-light btn-sm rounded-3 border text-danger mx-1 shadow-sm"
                        aria-label="Delete section"
                      >
                        <i class="bi bi-trash me-1"></i>
                        <span class="text-xxs">Delete</span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Create Section Modal -->
        <div class="modal fade" id="create_section" tabindex="-1" aria-labelledby="create_sectionModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-primary text-white position-relative">
                <p class="modal-title text-xxs fw-500" id="exampleModalLabel">Create Section</p>
                <!-- Close button on the end with white "X" -->
                <button
                  type="button"
                  class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
                  data-bs-dismiss="modal"
                  aria-label="Close">
                </button>
              </div>
              <form @submit.prevent="createSection">
                <div class="modal-body">
                  <div class="mb-3">
                    <label for="section_name" class="form-label text-xxs fw-500">Section Name <span
                        class="text-danger">*</span></label>
                    <input type="text" class="form-control rounded-5 text-xxs" id="section_name"
                      placeholder="Enter section name" v-model="section_name">
                    <p v-if="errors.section_name" class="text-danger text-xxs mt-1">{{ errors.section_name }}</p>
                  </div>
                  <div class="mb-3">
                    <label class="form-label text-xxs fw-500">Lock section</label>
                    <div class="form-check form-switch ms-3 mt-1">
                      <input class="form-check-input" type="checkbox" id="locked_toggle" v-model="is_locked">
                      <label class="form-check-label text-xxs" for="locked_toggle">
                        {{ is_locked ? 'Locked' : 'Unlocked' }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary text-xxs rounded-5">Save</button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- Edit Section Modal -->
        <div v-for="section in sections" :key="section.id" >
          <div
            class="modal fade"
            :id="'edit_section_' + section.id"
            tabindex="-1"
            aria-labelledby="edit_sectionModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header bg-primary text-white position-relative">
                  <p class="modal-title text-xxs fw-500">Edit Section</p>
                  <button
                    type="button"
                    class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
                    data-bs-dismiss="modal"
                    aria-label="Close">
                  </button>
                </div>
                <div class="modal-body">
                  <div class="mb-3">
                    <label class="form-label text-xxs fw-500">
                      Section Name <span class="text-danger">*</span>
                    </label>
                    <input 
                      type="text" 
                      class="form-control rounded-5 text-xxs" 
                      v-model="edit_section"
                      placeholder="Enter section name"
                    >
                  </div>
                </div>
                <div class="modal-footer">
                  <button @click="editSection(section)" type="submit" class="btn btn-primary text-xxs rounded-5">Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Edit Section Modal -->
      </div>
    </div>
  </div>
</div>